import Home from "./Home"
import FreeTrial from "./Freetrial"
import Settings from "./Settings"
import AIChat from "./AIChat"
import Calendar from "./calendar"
import Dashboard from "./Dashboard/Dashboard"
import LocationIntegration from "./Settings/components/LocationIntegration"
import YourAIAgents from "./YourAIAgents/YourAIAgents"
import Chat from "./Chat/index"
import OnboardingShortLink from "./Chat/OnboardingShortLink"

const useRoutes = () => {
  // const [user] = useUserInfo();
  return [
    {
      type: "collapse",
      key: "not_found",
      route: "/404",
      component: <></>,
    },
    {
      type: "collapse",
      key: "home",
      route: "/home",
      component: <Home />,
    },
    {
      type: "collapse",
      key: "home",
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      key: "freetrial",
      route: "/freetrial",
      component: <FreeTrial />,
    },
    {
      type: "collapse",
      key: "settings",
      route: "/settings",
      component: <Settings />,
    },
    {
      type: "collapse",
      key: "ai-agents",
      route: "/ai-agents",
      component: <YourAIAgents />,
    },
    {
      type: "collapse",
      key: "chat",
      route: "chat/*",
      component: <Chat />,
    },
    {
      type: "collapse",
      key: "aichat",
      route: "/aichat",
      component: <AIChat />,
    },
    {
      type: "collapse",
      key: "calendar",
      route: "/calendar",
      component: <Calendar />,
    },
    {
      type: "collapse",
      key: "location_integration",
      route: "/location_integration",
      component: <LocationIntegration />,
    },
    // Onboarding short links (/hubspot, /tool/xero, /xero?job_role=founder-ceo, ...).
    // React Router ranks static segments above dynamic ones regardless of
    // declaration order, so every route above (e.g. /calendar, /settings)
    // always wins over these — "reserved routes always win" falls out of the
    // router for free.
    {
      type: "collapse",
      key: "onboarding-tool",
      route: "/tool/:slug",
      component: <OnboardingShortLink axis="tool" />,
    },
    {
      type: "collapse",
      key: "onboarding-role",
      route: "/role/:slug",
      component: <OnboardingShortLink axis="role" />,
    },
    {
      type: "collapse",
      key: "onboarding-sector",
      route: "/sector/:slug",
      component: <OnboardingShortLink axis="sector" />,
    },
    {
      type: "collapse",
      key: "onboarding-category",
      route: "/category/:slug",
      component: <OnboardingShortLink axis="category" />,
    },
    {
      type: "collapse",
      key: "onboarding-short-link",
      route: "/:slug",
      component: <OnboardingShortLink />,
    },
    // Account Setup (/add-account-setup) is intentionally not registered here
    // — it's a standalone, full-page flow (no sidebar) and is mounted
    // directly in pages/index.js, outside the AppShell-wrapped route block.
    // {
    //   type: "collapse",
    //   key: "freetrial",
    //   route: "/free-trial",
    //   component: <FreeTrail />,
    // },
    // {
    //   type: "collapse",
    //   key: "authentication",
    //   route: "/auth/*",
    //   component: <Authentication />,
    //   guard: {
    //     valid: !user.email,
    //     redirect: `/dashboard`,
    //   },
    // },
    // {
    //   type: 'collapse',
    //   key: 'integration',
    //   route: '/integrations/*',
    //   component: <Integration />,
    // },
    // {
    //   type: "collapse",
    //   key: "superadmin",
    //   route: "/*",
    //   component: <SuperAdmin />,
    //   guard: {
    //     valid: user.email && user.roles.includes(Roles.AGENCY),
    //     redirect: "/auth/sign-in",
    //   },
    // },
  ];
};

export default useRoutes;
